import { useEffect, useMemo } from 'react';

/**
 * Object URL for a Blob, revoked automatically on unmount / blob change
 * so the <img> consumers don't leak a fresh URL per render. Shared by
 * CropModal, ImagePreviewModal and DebugPanel, which all previously
 * hand-rolled the same create/revoke pair.
 *
 * Overloaded so a caller with a guaranteed Blob gets a plain string back.
 */
export function useObjectUrl(blob: Blob): string;
export function useObjectUrl(blob: Blob | null): string | null;
export function useObjectUrl(blob: Blob | null): string | null {
  const url = useMemo(
    () => (blob === null ? null : URL.createObjectURL(blob)),
    [blob],
  );
  useEffect(() => {
    return () => {
      if (url !== null) URL.revokeObjectURL(url);
    };
  }, [url]);
  return url;
}
